/** In-memory only — survives SPA navigation, cleared on full page refresh. */
const justCopiedTaskIds = new Set<string>();

export function markJustCopiedTask(taskId: string): void {
  if (taskId) justCopiedTaskIds.add(taskId);
}

export function isJustCopiedTask(taskId: string): boolean {
  return justCopiedTaskIds.has(taskId);
}
